// Normalización de teléfonos argentinos, igual que en el backend.
//
// Está duplicado a propósito: el objetivo es avisarle a la persona que el
// número está mal ANTES de mandar el formulario, sin esperar el 422. El
// backend vuelve a normalizar por su cuenta y es el que manda; esto es sólo
// para que el error se vea al lado del campo.
//
// Si el algoritmo cambia allá, hay que cambiarlo acá. Es el precio de validar
// en el cliente sin compartir código entre los dos proyectos.

const AREAS_3 = new Set([
  '220', '221', '223', '230', '236', '237', '249', '260', '261', '263', '264',
  '266', '280', '291', '297', '299',
  '341', '342', '343', '345', '348', '351', '353', '358',
  '362', '364', '370', '376', '379', '381', '383', '385', '387', '388'
]);

const LARGO_NACIONAL = 10;

function largoDeArea(nacional) {
  if (nacional.startsWith('11')) return 2;
  if (AREAS_3.has(nacional.slice(0, 3))) return 3;
  return 4;
}

/** Devuelve E.164 sin el '+', o null si no se puede interpretar. */
export function normalizarTelefonoAR(entrada) {
  if (typeof entrada !== 'string' && typeof entrada !== 'number') return null;

  let digitos = String(entrada).replace(/[^\d]/g, '');
  if (digitos.length === 0) return null;

  if (digitos.startsWith('00')) digitos = digitos.slice(2);

  if (digitos.startsWith('54')) {
    digitos = digitos.slice(2);
  } else if (digitos.startsWith('0')) {
    digitos = digitos.replace(/^0+/, '');
  }

  if (digitos.length > LARGO_NACIONAL && digitos.startsWith('9')) {
    digitos = digitos.slice(1);
  }
  if (digitos.startsWith('0')) digitos = digitos.replace(/^0+/, '');

  if (digitos.length < LARGO_NACIONAL) return null;

  const area = digitos.slice(0, largoDeArea(digitos));
  let abonado = digitos.slice(area.length);
  const largoAbonado = LARGO_NACIONAL - area.length;

  // El 15 sólo se saca si los números cierran.
  if (abonado.length === largoAbonado + 2 && abonado.startsWith('15')) {
    abonado = abonado.slice(2);
  }

  const nacional = area + abonado;
  if (nacional.length !== LARGO_NACIONAL) return null;
  if (nacional.startsWith('0')) return null;

  return `549${nacional}`;
}

export function esTelefonoValido(entrada) {
  return normalizarTelefonoAR(entrada) !== null;
}

/**
 * '5493491123456' -> '+54 9 3491 123456'
 *
 * Sólo para mostrar. Lo que se manda al backend y lo que va en el link de
 * WhatsApp es siempre el E.164 sin espacios.
 */
export function telefonoLegible(e164) {
  if (!e164) return '';
  const digitos = String(e164).replace(/[^\d]/g, '');
  if (!digitos.startsWith('549') || digitos.length !== 13) return `+${digitos}`;

  const nacional = digitos.slice(3);
  const area = nacional.slice(0, largoDeArea(nacional));
  return `+54 9 ${area} ${nacional.slice(area.length)}`;
}
